import styled from 'styled-components'

export const BookingQuestionUiContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
